import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import axiosInstance from "../../api/axiosInstance";

/**
 * Route guard for PA-granted support-agent capabilities (KB_AUTHOR /
 * FORM_DESIGNER). The sidebar only HIDES the nav link for agents who lack the
 * capability — this enforces it at the route level so the authoring page can't
 * be reached by direct URL. The backend draft endpoints enforce it too; this is
 * the matching client-side gate so a capability-less agent never loads the page.
 */
export default function RequireCapability({ capability, fallback = "/admin/support/knowledge-base", children }) {
  // null = still checking, true/false = result
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let active = true;
    axiosInstance
      .get("/api/v1/support/me/capabilities")
      .then((res) => {
        const caps = res?.data?.body?.capabilities || [];
        if (active) setAllowed(caps.includes(capability));
      })
      .catch(() => {
        if (active) setAllowed(false);
      });
    return () => {
      active = false;
    };
  }, [capability]);

  if (allowed === null) {
    return (
      <div className="h-full flex items-center justify-center">
        <i className="pi pi-spin pi-spinner text-3xl" style={{ color: "#0369A1" }} />
      </div>
    );
  }

  return allowed ? children : <Navigate to={fallback} replace />;
}
